var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[_c('div',[_vm._m(0),_c('div',{staticClass:"btn-item"},[_c('div',{staticClass:"btn",on:{"click":_vm.goHome}},[_vm._v("返回首页")]),_c('div',{staticClass:"btn",on:{"click":_vm.goSuperior}},[_vm._v("返回上一页")])])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{attrs:{"src":require("../assets/serach/Illustration.png"),"alt":""}})])
}]

export { render, staticRenderFns }